import { createFileRoute } from '@tanstack/react-router';

import { ConferenceBrowse } from '@/module/Conference';

export const Route = createFileRoute('/_auth/conference/_conference/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ConferenceBrowse />;
}
